import { render, staticRenderFns } from "./StyleProperties.vue?vue&type=template&id=cce24258&scoped=true"
import script from "./StyleProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./StyleProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StyleProperties.vue?vue&type=style&index=0&id=cce24258&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce24258",
  null
  
)

export default component.exports